import { axios } from "./Axios";
import { HttpForm } from "./HttpForm";
export class IndexModel extends HttpForm {
    loaded = false;
    page = 1;
    filters = {};
    prefix = '/api/';
    data = false;
    selected = false;
    load(append = false) {
        return this.loadIndex(this.endpoint, append).catch(e => this.setError(e));
    }
    getData() {
        if (this.data) {
            return this.data.data;
        }
        return [];
    }
    resetFilters() {
        return this.load();
    }
    loadIndex(endpoint, append = false) {
        if (!append) {
            this.page = 1;
            this.setLoading();
        }
        this.resetErrorStatus();
        let url = this.prefix + endpoint + this.buildQueryParameters();
        return axios.get(url)
            .then(response => {
            let responseData = response.data;
            this.processIndexData(responseData, append);
        })
            .then(() => this.setLoadingComplete())
            .catch(e => this.setError(e));
    }
    resetIndexData() {
        return new Promise(resolve => {
            this.page = 1;
            this.loaded = false;
            this.data = false;
            resolve(true);
        });
    }
    processIndexData(response, append = false) {
        if (!this.data || !append) {
            this.data = response;
        }
        else {
            this.data.data.push(...response.data);
        }
        return this.data;
    }
    buildQueryParameters() {
        let params = '?page=' + this.page;
        for (const key in this.filters) {
            let value = this.filters[key];
            if (value !== null) {
                params = params + '&' + key + '=' + value;
            }
        }
        return params;
    }
    hasResults() {
        return this.data && this.data.data.length > 0;
    }
    indexHasMoreResults() {
        if (this.data) {
            return this.data.meta && (this.page <= this.data.meta.last_page);
        }
        return false;
    }
    loadNextPage(action) {
        if (this.data === false) {
            this.load().then(() => {
                this.data && this.data.data.length > 0 ? action.loaded(1) : action.loaded(0);
            }).catch(e => {
                action.error();
                this.setError(e);
            });
        }
        else {
            this.page += 1;
            let moreResults = this.indexHasMoreResults();
            if (moreResults) {
                this.load(true).catch(e => {
                    action.error();
                    this.setError(e);
                });
            }
            return action.loaded(moreResults ? 1 : 0);
        }
    }
    isLoaded() {
        return this.loaded;
    }
    setLoading() {
        this.loaded = false;
    }
    setLoadingComplete() {
        this.loaded = true;
    }
    hasSelectedItem() {
        return this.selected !== false;
    }
    selectIndexItem(index, toggle = true) {
        if (toggle && this.selected === index) {
            this.selected = false;
        }
        else {
            this.selected = this.getData()[index];
        }
    }
}
